import useDtPortfolio from './useDtPortfolio';
import useDtPortfolioByCode from './useDtPortfolioByCode';

export default {
  useDtPortfolio,
  useDtPortfolioByCode,
};
